namespace SPA
{
	export namespace BWS
	{

		export enum FormState
		{
			NULL,
			NEW,
			OLD,
		}

		export class New
			extends ui.tab.TabHTMLPresentation
			{
				private MCustomerBox: 				ui.Box.Box;
				private MOwnerBox: 						ui.Box.Box;
				private MObjectAddressBox: 		ui.Box.Box;
				private MObjectDefinitionBox: ui.Box.Box;
				private MNHKBox: 							ui.Box.Box;
				private MButtonBox: 					ui.Box.Box;
				private MForm: 								ui.Form.Form;
				private Company: 							Wollmilch.CompanyObject;

				private HTMLForm: 						JQuery;

				// @ts-ignore
				private MNewClient: 					ui.dialog.Modal;
				private	MCustomerInputs:			Array<ui.Form.BasicInputField<HTMLElement>>;
				private	MCustomerList:				any[];
				private	MObjectOwner:					Array<ui.Form.BasicInputField<HTMLElement>>;
				private	MFormState:						FormState;
				private MNewClientForm: 			ui.Form.Form;
				private	MNewClientInputs:			Array<ui.Form.BasicInputField<HTMLElement>>;

				private street:								ui.Form.TextInput;
				private housenumber:					ui.Form.TextInput;
				private postalcode:						ui.Form.TextInput;
				private city:									ui.Form.TextInput;
				private ownername:						ui.Form.TextInput;
				private ownersalutation:			ui.Form.Select;
				private ownersurname:					ui.Form.TextInput;
				private ownerstreet:					ui.Form.TextInput;
				private ownerhousenumber:			ui.Form.TextInput;
				private ownerpostalcode:			ui.Form.TextInput;
				private ownercity:						ui.Form.TextInput;
				private objectBuildingyear: 	ui.Form.NumberInput;
				private objectPlotarea: 			ui.Form.NumberInput;
				private objectEstimatedPrice: ui.Form.NumberInput;
				private objectBruttoArea: 		ui.Form.NumberInput;
				private customer: 						Wollmilch.ClientObject|null;
				private TheObject: 						Wollmilch.Realtor.Object|null;
				private parent: 							string|null;
				private staticForm: 					any;

				private newClientGender: 			ui.Form.TextInput;
				private newClientName: 				ui.Form.TextInput;
				private newClientSurame: 			ui.Form.TextInput;
				private newClientStreet: 			ui.Form.TextInput;
				private newClientHousenumber: ui.Form.TextInput;
				private newClientPostalCode: 	ui.Form.TextInput;
				private newClientCity: 				ui.Form.TextInput;
				private newClientEmail: 			ui.Form.TextInput;

				// @ts-ignore
				private selectGebaeudetypElement:		ui.Form.Select;												// MFH, ...
				private selectGebaeudetypItem:			string;

				private selectBauartElement:				SPA.gui.component.CheckableList;			// Keller, Dach, ...
				private selectBauartList:						any;
				private selectBauartItem:						string;

				// @ts-ignore
				private selectBauartTypElement:			ui.Form.RadioGroup;										// Kopfhaus, ...
				private selectBauartTypList:				any;
				private selectBauartTypItem:				string;

				// @ts-ignore
				private selectAusstattungElement:		ui.Form.Select;
				private selectAusstattungList:			any;
				private selectAusstattungItem:			string;
				private currentobject: 							any;

				public constructor( company: Wollmilch.CompanyObject, TheObject: Wollmilch.Realtor.Object|null = null)
				{
					super();

					this.Initialize( {} );

					TheObject ? this.TheObject = TheObject : this.TheObject = null;

					this.MCustomerBox = new ui.Box.Box();
					this.MCustomerBox.addTitle( app.getMessage( 'BWS.GENERAL.boxtitleCustomer' ) );
					this.MCustomerBox.rebuild();

					this.MOwnerBox = new ui.Box.Box();
					this.MOwnerBox.addTitle( app.getMessage( 'BWS.GENERAL.boxtitleOwner' ) );
					this.MOwnerBox.rebuild();

					this.MObjectAddressBox = new ui.Box.Box();
					this.MObjectAddressBox.addTitle( app.getMessage( 'BWS.GENERAL.boxtitleObjectAddress' ) );
					this.MObjectAddressBox.rebuild();

					this.MObjectDefinitionBox = new ui.Box.Box();
					this.MObjectDefinitionBox.addTitle( app.getMessage( 'BWS.GENERAL.boxtitleObjectDefinition' ) );
					this.MObjectDefinitionBox.rebuild();

					this.MNHKBox = new ui.Box.Box();
					this.MNHKBox.rebuild();

					this.MButtonBox = new ui.Box.Box();
					this.MButtonBox.rebuild();

					this.MFormState = FormState.NULL;
					this.MCustomerList = [];
					this.MCustomerInputs	= [];
					this.Company = company;
					this.customer = null;

					this.MNewClientForm = new ui.Form.Form(
					{
						action: 'organization/new/Client',
						classes: [ 'form-horizontal' ],
						invalid: ( inputs: Array<ui.Form.BasicInputField<HTMLElement>> ) =>
						{
							app.addNotify(
							{
								body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) ) ],
								context: 'danger',
								timeout: Number(app.getConfigValue("ToastTimeout")),
								title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
							});
						},
						method: 'POST',
						notSwitchable: true,
						submit: ( Method, action: string, parameter: ui.Form.IFormParameter ) =>
						{
							//
						},
					},
					);
					this.MNewClientInputs = [];

					this.newClientGender				= new ui.Form.TextInput( '', '' );
					this.newClientName					= new ui.Form.TextInput( '', '' );
					this.newClientSurame				= new ui.Form.TextInput( '', '' );
					this.newClientStreet				= new ui.Form.TextInput( '', '' );
					this.newClientHousenumber		= new ui.Form.TextInput( '', '' );
					this.newClientPostalCode		= new ui.Form.TextInput( '', '' );
					this.newClientCity					= new ui.Form.TextInput( '', '' );
					this.newClientEmail					= new ui.Form.TextInput( '', '' );

					this.MObjectOwner		= new Array();
					this.parent					= null;

					this.selectGebaeudetypItem				= '1';
					this.selectBauartElement					= new SPA.BRW.gui.CheckableList(
						{ multiple: false, required: true, name: 'NHK2010', horizontal: true },
					);
					this.selectBauartElement.addClass( 'control-label col-xs-12 col-md-10' )
						.css( {'overflow': 'auto', 'text-align': 'center' } );
					this.selectBauartList							= [];
					this.selectBauartItem							= '1.11';

					this.selectBauartTypList 					= [];
					this.selectBauartTypItem					= '1';
					this.selectAusstattungList				= [];
					this.selectAusstattungItem				= '1';

					Object.keys(app.getMessage( 'BWS.TYP.1.kindof' )).forEach( (element: any) =>
					{
						this.selectBauartTypList[ element ] = { value: element, title: app.getMessage( 'BWS.TYP.1.kindof' )[element] };
					});

					Object.keys(app.getMessage( 'BWS.TYP.1.equipments' )).forEach( (element: any) =>
					{
						this.selectAusstattungList[ element ] = app.getMessage( 'BWS.TYP.1.equipments' )[element];
					});

					Object.keys(app.getMessage( 'BWS.TYP.1.list' )).forEach( (element: any) =>
					{
						this.selectBauartList[ element ] = app.getMessage( 'BWS.TYP.1.list' )[element];
					});

					this.Root()
						.append( ui.$$.div().addClass( 'row' )
								.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' ).append( this.MCustomerBox.Root() ) )
								.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' ).append( this.MOwnerBox.Root() ) ),
						)
						.append( ui.$$.div().addClass( 'row' )
								.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' ).append( this.MObjectAddressBox.Root() ) )
								.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' ).append( this.MObjectDefinitionBox.Root() ) ),
						)
						.append( ui.$$.div().addClass( 'row' )
							.append( ui.$$.div().addClass( 'col-sm-12 col-md-12' ).append( this.MNHKBox.Root() ) ),
						)
						.append( ui.$$.div().addClass( 'row' )
								.append( ui.$$.div().addClass( 'col-sm-12 col-md-12' ).append( this.MButtonBox.Root() ) ),
						);

					this.HTMLForm = $( document.createElement( 'form' ) );

					this.street													= new ui.Form.TextInput( '', '' );
					this.housenumber										= new ui.Form.TextInput( '', '' );
					this.postalcode											= new ui.Form.TextInput( '', '' );
					this.city														= new ui.Form.TextInput( '', '' );
					this.ownersalutation								= new ui.Form.Select( { name: '', option: { } } );
					this.ownername											= new ui.Form.TextInput( '', '' );
					this.ownersurname										= new ui.Form.TextInput( '', '' );
					this.ownerstreet										= new ui.Form.TextInput( '', '' );
					this.ownerhousenumber								= new ui.Form.TextInput( '', '' );
					this.ownerpostalcode								= new ui.Form.TextInput( '', '' );
					this.ownercity											= new ui.Form.TextInput( '', '' );
					this.objectBuildingyear							= new ui.Form.NumberInput( 0, '' );
					this.objectPlotarea									= new ui.Form.NumberInput( 0, '' );
					this.objectEstimatedPrice						= new ui.Form.NumberInput( 0, '' );
					this.objectBruttoArea								= new ui.Form.NumberInput( 0, '' );

					this.MForm = new ui.Form.Form(
					{
						action: '',
						classes: [ 'form-horizontal' ],
						invalid: ( inputs: Array<ui.Form.BasicInputField<HTMLElement>> ) =>
						{
							app.addNotify(
							{
								body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) ) ],
								context: 'danger',
								timeout: Number(app.getConfigValue("ToastTimeout")),
								title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
							});
						},
						method: 'POST',
						notSwitchable: true,
						submit: ( methode: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) => { /* */ },
					},
					);

					this.append( this.MForm );
					this.MForm.Initialize();

					this.rebuild( this.Root() );

					this.readLoginDataFromDB();

					this.rebuild( this.Root() );
				}

				public rebuild( root: JQuery|ui.base.BaseHTMLElement ): New
				{
					super.rebuild( root );

					return this;
				}

				private addObjDataInput( input: ui.Form.BasicInputField, baseclass: string[] ): void {
					this.MForm.Input( input ); input.Base().addClass( baseclass.join( ' ' ) );
				}

				private readLoginDataFromDB(): void
				{
					new Wollmilch.AJAX(
					{
						method: 'GET',
						on:
						{
							success: ( text: string ): void =>
							{
								let obj = null;
								try
								{
									obj = Wollmilch.jsonize( text );
								}
								catch ( e )
								{
									app.addNotify(
									{
										body: [ ui.text( app.getMessage( 'BWS.ERROR.nojson' ) ) ],
										context: 'danger',
										timeout: Number(app.getConfigValue("ToastTimeout")),
										title: [ ui.h( 4, app.getMessage( 'BWS.ERROR.title' ) ) ],
									});
									return;
								}

								if ( obj && !obj.success )
								{
									app.addNotify(
									{
										body: [ ui.text( app.getMessage( 'BWS.ERROR.nosuccess' ) ) ],
										context: 'danger',
										timeout: Number(app.getConfigValue("ToastTimeout")),
										title: [ ui.h( 4, app.getMessage( 'BWS.ERROR.title' ) ) ],
									});
									return;
								}

								if ( obj != null )
								{
									this.buildNewInputForm();
									this.buildNewBWSForm( obj.data );
								}
							},
						},
						url: 'BWS/loadLoginData',
					},
					Wollmilch.AJAXCallbase_e.BWS,
					).send();
				}

				private buildNewBWSForm( obj: Wollmilch.BWS.ILogin ): void
				{
					this.addObjDataInput( new ui.Form.HiddenTextInput( obj.login, 'login' ), [] );
					this.addObjDataInput( new ui.Form.HiddenTextInput( obj.username, 'username' ), [] );
					this.addObjDataInput( new ui.Form.HiddenTextInput( obj.password, 'password' ), [] );
					this.addObjDataInput( new ui.Form.HiddenTextInput( obj.token, 'token' ), [] );

					this.parent = this.TheObject ? this.TheObject.ObjectNumber : null;
					this.addObjDataInput( new ui.Form.HiddenTextInput( this.parent, 'Parent' ), [] );

					this.append( this.HTMLForm );

					this.HTMLForm	.attr( 'action', 'http://192.168.0.201/test_bws_wms/login_WMS.php' )
												.attr( 'method', 'POST' )
												.attr( 'target', '4171667b-32a4-43a9-9fb7-c627b622fa04' );

					$( new Button(
						{
							on:
							{
								click: () =>
								{
									// überprüfen dass alle Felder gefüllt sind
									let err = false;

									if ( this.city.val() === null ) { this.city.addClass('has-error'); err = true; }
										else { this.city.addClass('has-success'); }
									if ( this.housenumber.val() === null ) { this.housenumber.addClass('has-error'); err = true; }
										else { this.housenumber.addClass('has-success'); }
									if ( this.selectBauartElement.val() === null ) { this.selectBauartElement.addClass('has-error'); err = true; }
										else { this.selectBauartElement.addClass('has-success'); }
									if ( this.selectAusstattungElement.val() === null )
										{ this.selectAusstattungElement.addClass('has-error'); err = true; }
										else { this.selectAusstattungElement.addClass('has-success'); }
									if ( this.objectBruttoArea.val() === null ) { this.objectBruttoArea.addClass('has-error'); err = true; }
										else { this.objectBruttoArea.addClass('has-success'); }
									if ( this.objectBuildingyear.val() === null ) { this.objectBuildingyear.addClass('has-error'); err = true; }
										else { this.objectBuildingyear.addClass('has-success'); }
									if ( this.objectEstimatedPrice.val() === null )
										{ this.objectEstimatedPrice.addClass('has-error'); err = true; }
										else { this.objectEstimatedPrice.addClass('has-success'); }
									if ( this.objectPlotarea.val() === null ) { this.objectPlotarea.addClass('has-error'); err = true; }
										else { this.objectPlotarea.addClass('has-success'); }
									if ( this.objectPlotarea.val() === null ) { this.objectPlotarea.addClass('has-error'); err = true; }
										else { this.objectPlotarea.addClass('has-success'); }
									if ( this.ownercity.val() === null ) { this.ownercity.addClass('has-error'); err = true; }
										else { this.ownercity.addClass('has-success'); }
									if ( this.ownerhousenumber.val() === null ) { this.ownerhousenumber.addClass('has-error'); err = true; }
										else { this.ownerhousenumber.addClass('has-success'); }
									if ( this.ownername.val() === null ) { this.ownername.addClass('has-error'); err = true; }
										else { this.ownername.addClass('has-success'); }
									if ( this.ownerpostalcode.val() === null ) { this.ownerpostalcode.addClass('has-error'); err = true; }
										else { this.ownerpostalcode.addClass('has-success'); }
									if ( this.ownerstreet.val() === null ) { this.ownerstreet.addClass('has-error'); err = true; }
										else { this.ownerstreet.addClass('has-success'); }
									if ( this.ownersurname.val() === null ) { this.ownersurname.addClass('has-error'); err = true; }
										else { this.ownersurname.addClass('has-success'); }
									if ( this.postalcode.val() === null ) { this.postalcode.addClass('has-error'); err = true; }
										else { this.postalcode.addClass('has-success'); }
									if ( this.street.val() === null ) { this.street.addClass('has-error'); err = true; }
										else { this.street.addClass('has-success'); }
									if ( this.ownersalutation.val() === 'Herr' || this.ownersalutation.val() === 'Frau' )
										{ this.ownersalutation.addClass('has-success'); }
										else { this.ownersalutation.addClass('has-error'); err = true; }

									if ( err )
									{
										app.addNotify(
										{
											body: [ ui.text( app.getMessage( 'BWS.ERROR.notallfieldsdielled' ) ) ],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout")),
											title: [ ui.h( 4, app.getMessage( 'BWS.ERROR.title' ) ) ],
										});
										err = false;
									}
									else
									{
										new Wollmilch.AJAX(
										{
											data:
											{
												Parent: this.parent,
												city: this.city.val(),
												customer: this.customer,
												housenumber: this.housenumber.val(),
												nhk2010: this.selectBauartElement.val(),
												nhkEquipment: this.selectAusstattungElement.val(),
												objectBruttoArea: this.objectBruttoArea.val(),
												objectBuildingyear: this.objectBuildingyear.val(),
												objectEstimatedPrice: this.objectEstimatedPrice.val(),
												objectPlotarea: this.objectPlotarea.val(),
												ownercity: this.ownercity.val(),
												ownerhousenumber: this.ownerhousenumber.val(),
												ownername: this.ownername.val(),
												ownerpostalcode: this.ownerpostalcode.val(),
												ownersalutation: this.ownersalutation.val(),
												ownerstreet: this.ownerstreet.val(),
												ownersurname: this.ownersurname.val(),
												postalcode: this.postalcode.val(),
												street: this.street.val(),
											},
											method: 'POST',
											on:
											{
												success: ( text: string ): void =>
												{
													let obj_ = null;
													try
													{
														obj_ = Wollmilch.jsonize( text );
													}
													catch ( e )
													{
														app.addNotify(
														{
															body: [ ui.text( app.getMessage( 'BWS.ERROR.nojson' ) ) ],
															context: 'danger',
															timeout: Number(app.getConfigValue("ToastTimeout")),
															title: [ ui.h( 4, app.getMessage( 'BWS.ERROR.title' ) ) ],
														});
														return;
													}

													if ( obj_ && !obj_.success )
													{
														app.addNotify(
														{
															body: [ ui.text( app.getMessage( 'BWS.ERROR.nosuccess' ) ) ],
															context: 'danger',
															timeout: Number(app.getConfigValue("ToastTimeout")),
															title: [ ui.h( 4, app.getMessage( 'BWS.ERROR.title' ) ) ],
														});
														return;
													}

													if ( obj_ != null )
													{
														this.addObjDataInput( new ui.Form.HiddenTextInput(
															encodeURIComponent( btoa( obj_.data.objectNumber ) ),
															'objectNumber' ), [],
														);
														this.addObjDataInput( new ui.Form.HiddenTextInput(
															app.getAuthenticationManager().getAuthToken(),
															'WMSAuthToken' ), [],
														);

														this.HTMLForm = this.convertIntoPostForm( this.staticForm, this.HTMLForm );
														this.HTMLForm = this.convertIntoPostForm( this.MForm, this.HTMLForm );

														this.HTMLForm.submit();

														// TODO wieder aktivieren
														// app.getGlobalTabControl().removeTab( this.m_Entry );
													}
												},
											},
											url: 'BWS/new',
										},
										Wollmilch.AJAXCallbase_e.BWS,
										).send();
									}
								},
							},
							style: 'success',
							title: app.getMessage( 'BWS.LABEL.btnNew' ),
						},
						).getElement(),
					).appendTo( this.MButtonBox.Root() );

					this.MObjectAddressBox.append( this.HTMLForm );
				}

				private convertIntoPostForm( MForm: ui.Form.Form, myForm: JQuery ): JQuery
				{
					const field = MForm.Input();

					Object.keys( field ).forEach( function( key )
					{
						const newField							= document.createElement( 'input' );

						newField.type 							= 'text';
						// @ts-ignore
						newField.name 							= field[key].Name.toString();
						newField.value 							= field[key].val();
						newField.style.display			= 'none';

						myForm.append( newField );
					});
					return myForm;
				}

				private buildNewInputForm(): void
				{
					this.buildOldCustomerForm();
					this.showOwnerInputFields();
					this.showAddressInputFields();
					this.showObjectInputFields();
					this.showNKHInputFields();
				}

				private showOwnerInputFields(): void
				{
					this.MOwnerBox.append(
						$(
							new Button(
							{
								classes: [ 'pull-right' ],
								on:
								{
									click: () =>
									{
										this.MCustomerInputs.forEach( (element) =>
										{
											if ( element && element.Name )
											{
												if ( element.Name === "Customer_Salutation" ) { this.ownersalutation.value( element.val() ); }
												if ( element.Name === "Customer_Firstname" ) { this.ownername.value( element.val() ); }
												if ( element.Name === "Customer_Surname" ) { this.ownersurname.value( element.val() ); }
												if ( element.Name === "Customer_Street" ) { this.ownerstreet.value( element.val() ); }
												if ( element.Name === "Customer_Housenumber" ) { this.ownerhousenumber.value( element.val() ); }
												if ( element.Name === "Customer_Postalcode" ) { this.ownerpostalcode.value( element.val() ); }
												if ( element.Name === "Customer_City" ) { this.ownercity.value( element.val() ); }
											}
										});
									},
								},
								size: 'sm',
								style: 'info',
								title: app.getMessage( 'BWS.LABEL.btnFromCustomer' ),
							},
							).getElement(),
						),
					);

					this.ownersalutation = new ui.Form.Select(
					{
						name: 'Owner_Salutation',
						option:
						{
							Frau: app.getMessage( 'BWS.INPUTS.salutation.woman' ),
							Herr: app.getMessage( 'BWS.INPUTS.salutation.man' ),
						},
					},
					).value('Herr');

					this.ownersurname = new ui.Form.TextInput
					// @ts-ignore
					(	this.TheObject ? this.TheObject.Customer.Customer.Surname : '',
						{ name: 'Owner_Surname', placeholder: app.getMessage( 'BWS.INPUTS.surname' ), required: true } );

					this.ownername = new ui.Form.TextInput
					( this.TheObject ? this.TheObject.Customer.Customer.Name : '',
						{ name: 'Owner_Firstname', placeholder: app.getMessage( 'BWS.INPUTS.firstname' ), required: true } );

					let fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.name' ) + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MOwnerBox.Root() );

					this.addObjDataInput( this.ownersalutation.rebuild( fg ), [ 'col-xs-12', 'col-md-2' ] );
					this.addObjDataInput( this.ownername.rebuild( fg ), [ 'col-xs-12', 'col-md-4' ] );
					this.addObjDataInput( this.ownersurname.rebuild( fg ), [ 'col-xs-12', 'col-md-4' ] );

					this.ownerstreet = new ui.Form.TextInput
					// @ts-ignore
					( this.TheObject ? this.TheObject.Customer.Customer.Address[0].Street : '',
						{ name: 'Owner_Street', placeholder: app.getMessage( 'BWS.INPUTS.street' ), required: true } );

					this.ownerhousenumber = new ui.Form.TextInput
					// @ts-ignore
					( this.TheObject ? this.TheObject.Customer.Customer.Address[0].HouseNumber : '',
						{ name: 'Owner_Housenumber', placeholder: app.getMessage( 'BWS.INPUTS.housenumber' ), required: true } );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.streetCombi' ) + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MOwnerBox.Root() );

					this.addObjDataInput( this.ownerstreet.rebuild( fg ), [ 'col-xs-12', 'col-md-8' ] );
					this.addObjDataInput( this.ownerhousenumber.rebuild( fg ), [ 'col-xs-12', 'col-md-2' ] );

					this.ownerpostalcode = new ui.Form.TextInput
					// @ts-ignore
					( this.TheObject ? this.TheObject.Customer.Customer.Address[0].PostalCode : '',
						{ name: 'Owner_Postalcode',
						placeholder: app.getMessage( 'BWS.INPUTS.postalcode' ), required: true } );

					this.ownercity = new ui.Form.TextInput
					// @ts-ignore
					( this.TheObject ? this.TheObject.Customer.Customer.Address[0].City : '',
						{ name: 'Owner_City', placeholder: app.getMessage( 'BWS.INPUTS.city' ), required: true } );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.cityCombi' ) + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MOwnerBox.Root() );

					this.addObjDataInput( this.ownerpostalcode.rebuild( fg ), [ 'col-xs-12', 'col-md-2' ] );
					this.addObjDataInput( this.ownercity.rebuild( fg ), [ 'col-xs-12', 'col-md-8' ] );
				}

				private showAddressInputFields(): void
				{
					this.MObjectAddressBox.append(
						$(
							new Button(
							{
								classes: [ 'pull-right' ],
								on:
								{
									click: () =>
									{
										this.street.value( this.ownerstreet.val() );
										this.housenumber.value( this.ownerhousenumber.val() );
										this.postalcode.value( this.ownerpostalcode.val() );
										this.city.value( this.ownercity.val() );
									},
								},
								size: 'sm',
								style: 'info',
								title: app.getMessage( 'BWS.LABEL.btnFromOwner' ),
							},
							).getElement(),
						),
					);

					this.MForm.appendTo( this.MObjectAddressBox );

					this.street = new ui.Form.TextInput
					// @ts-ignore
					(this.TheObject ? this.TheObject.Object.Address.Street : '',
						{ name: 'Address_Street', placeholder: app.getMessage( 'BWS.INPUTS.street' ), required: true } );

					this.housenumber = new ui.Form.TextInput
					// @ts-ignore
					(this.TheObject ? this.TheObject.Object.Address.HouseNumber : '',
						{ name: 'Address_Housenumber', placeholder: app.getMessage( 'BWS.INPUTS.housenumber' ), required: true } );

					let fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.streetCombi' )  + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MObjectAddressBox.Root() );

					this.addObjDataInput( this.street.rebuild( fg ), [ 'col-xs-12', 'col-md-8' ] );
					this.addObjDataInput( this.housenumber.rebuild( fg ), [ 'col-xs-12', 'col-md-2' ] );

					this.postalcode = new ui.Form.TextInput
					// @ts-ignore
					(this.TheObject ? this.TheObject.Object.Address.PostalCode : '',
						{ name: 'Address_Postalcode', placeholder: app.getMessage( 'BWS.INPUTS.postalcode' ), required: true } );

					this.city = new ui.Form.TextInput
					// @ts-ignore
					(this.TheObject ? this.TheObject.Object.Address.City : '',
						{ name: 'Address_City', placeholder: app.getMessage( 'BWS.INPUTS.city' ), required: true } );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.cityCombi' ) + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MObjectAddressBox.Root() );
					this.addObjDataInput( this.postalcode.rebuild( fg ),
						[ 'col-xs-12', 'col-md-2' ],
					);

					this.addObjDataInput( this.city.rebuild( fg ),
						[ 'col-xs-12', 'col-md-8' ],
					);

					const country = new ui.Form.TextInput
					( '',
						{ name: 'Address_Country', placeholder: app.getMessage( 'BWS.INPUTS.country' ), required: false } );

					const state = new ui.Form.TextInput
					( '',
						{ name: 'Address_State', placeholder: app.getMessage( 'BWS.INPUTS.state' ), required: false } );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label()
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MObjectAddressBox.Root() );
					this.addObjDataInput( country.rebuild( fg ),
						[ 'col-xs-12', 'col-md-5' ],
					);

					this.addObjDataInput( state.rebuild( fg ),
						[ 'col-xs-12', 'col-md-5' ],
					);
				}

				private showObjectInputFields(): void
				{
					const inputArea = new ui.Form.Select(
					{
						name: 'Object_Selected',
						option:
						{
							bruttoarea: app.getMessage( 'BWS.INPUTS.areaSelect.bruttoarea' ),
							livingarea: app.getMessage( 'BWS.INPUTS.areaSelect.livingarea' ),
						},
					},
					).value( 'bruttoarea' );

					this.objectBruttoArea = new ui.Form.NumberInput
					( 100, { min: 0, name: 'Object_Area', required: true } );

					let fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.area' ) + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MObjectDefinitionBox.Root() );

					this.addObjDataInput( inputArea.rebuild( fg ), [ 'col-xs-12', 'col-md-5' ] );
					this.addObjDataInput( this.objectBruttoArea.rebuild( fg ), [ 'col-xs-12', 'col-md-5' ] );

					this.objectBuildingyear = new ui.Form.NumberInput
					( (this.TheObject && this.TheObject.Premise && this.TheObject.Premise.Building )
						? this.TheObject.Premise.Building[0].Data.General.BuildYear : 2010,
						{ min: 1800, name: 'Object_Buildingyear', required: true } );

					this.objectPlotarea = new ui.Form.NumberInput
					( (this.TheObject && this.TheObject.Premise && this.TheObject.Premise.Data && this.TheObject.Premise.Data.General
						&& this.TheObject.Premise.Data.General.PlotArea && this.TheObject.Premise.Data.General.PlotArea.Premise )
						? parseInt(this.TheObject.Premise.Data.General.PlotArea.Premise.toString(), 10) : 111,
						{ min: 0, name: 'Object_Plotarea', required: true } );

					this.objectEstimatedPrice = new ui.Form.NumberInput
					( (this.TheObject && this.TheObject.Premise && this.TheObject.Premise.Building
						&& this.TheObject.Premise.Building[0] && this.TheObject.Premise.Building[0].Data
						&& this.TheObject.Premise.Building[0].Data.General
						&& this.TheObject.Premise.Building[0].Data.General.EstimatedPrice )
						? this.TheObject.Premise.Building[0].Data.General.EstimatedPrice : 0,
						{ min: 0, name: 'Object_EstimatedPrice', required: false } );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.buildingyear' ) + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MObjectDefinitionBox.Root() );
					this.addObjDataInput( this.objectBuildingyear.rebuild( fg ), [ 'col-xs-12', 'col-md-5' ] );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.plotarea' ) + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MObjectDefinitionBox.Root() );
					this.addObjDataInput( this.objectPlotarea.rebuild( fg ), [ 'col-xs-12', 'col-md-5' ] );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'BWS.INPUTS.estimatedPrice' ) )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MObjectDefinitionBox.Root() );
					this.addObjDataInput( this.objectEstimatedPrice.rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );
				}

				private showNKHInputFields(): void
				{
					let fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage('BWS.GENERAL.buildingtyp') )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MNHKBox.Root() );

					this.selectGebaeudetypElement = new ui.Form.Select(
					{
						name: 'NHK_G',
						on:
						{
							change: () =>
							{
								this.buildNHKItems();
							},
						},
						option:
						{
							"-1": app.getMessage('BWS.TYP.-1.name'),
							"-10": app.getMessage('BWS.TYP.-10.name'),
							"1": app.getMessage('BWS.TYP.1.name'),
							"2": app.getMessage('BWS.TYP.2.name'),
							"3": app.getMessage('BWS.TYP.3.name'),
						},
					},
					this.selectGebaeudetypItem,
					);

					this.addObjDataInput(
						this.selectGebaeudetypElement.rebuild( fg ),
						[ 'col-xs-12', 'col-md-4' ],
					);

					this.selectBauartTypElement = new ui.Form.RadioGroup(
					{
						inline: 3,
						name: 'NHK_B',
						on:
						{
							change: () =>
							{
								this.selectBauartTypItem = this.selectBauartTypElement.val() as string;
								this.buildNHKItems( true );
							},
						},
						radioButtons: this.selectBauartTypList,
						required: true,
						value: this.selectBauartTypItem,
					},
					);

					this.selectBauartTypElement.Base().addClass( 'col-xs-12 col-md-6' );
					this.selectBauartTypElement.rebuild( fg );

					this.selectBauartElement = new SPA.BRW.gui.CheckableList(
						{ multiple: false, required: true, name: 'NHK2010', horizontal: true },
					);
					this.selectBauartElement.addClass( 'control-label col-xs-12 col-md-10' )
						.css( {'overflow': 'auto', 'text-align': 'center' } );

					if ( this.selectGebaeudetypItem !== '-10' )
					{
						fg = ui.$$.div()
						.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage('BWS.GENERAL.nhk_object_typ') )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MNHKBox.Root() );

						for (const key in this.selectBauartList)
						{
							if (this.selectBauartList.hasOwnProperty(key))
							{
								const element = this.selectBauartList[key];

								this.selectBauartElement.add(
								{
									Item: this.selectGebaeudetypItem,
									Key: key,
									Name: element,
									Typ: this.selectBauartTypItem,
								},
								( this.selectBauartItem.substring( 2, 4 ) === key ) ? true : false,
								);
							}
						}
					}
					else
					{
						this.selectBauartElement.empty();
					}

					this.selectBauartElement.rebuild( fg );
					this.MForm.Input( this.selectBauartElement );

					fg = ui.$$.div()
					.addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage('BWS.GENERAL.equipments') )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MNHKBox.Root() );
					this.selectAusstattungElement = new ui.Form.Select(
					{
						name: 'NHK_E',
						option: this.selectAusstattungList,
					},
					this.selectAusstattungItem,
					);
					this.addObjDataInput(
						this.selectAusstattungElement.rebuild( fg ),
						[ 'col-xs-12', 'col-md-10' ],
					);

				}

				private buildNHKItems( ct: boolean = false, showFromDB: boolean = false ): void
				{
					if ( !showFromDB )
					{
						this.selectGebaeudetypItem = this.selectGebaeudetypElement.val() as string;
					}

					this.selectBauartList 			= app.getMessage( 'BWS.TYP.' + this.selectGebaeudetypItem + '.list' );
					this.selectBauartTypList 		= [];
					this.selectAusstattungList 	= app.getMessage( 'BWS.TYP.' + this.selectGebaeudetypItem + '.equipments' );

					this.selectBauartElement.clear();

					Object.keys(app.getMessage( 'BWS.TYP.' + this.selectGebaeudetypItem + '.kindof' ))
						.forEach( (element: any) =>
						{
							this.selectBauartTypList[element] =
							{
								title: app.getMessage( 'BWS.TYP.' + this.selectGebaeudetypItem + '.kindof' )[element],
								value: element,
							};
						});

					if ( this.selectGebaeudetypItem === '2' && this.selectBauartTypItem < '2' )
					{
						this.selectBauartTypItem = '2';
					}
					else if ( this.selectGebaeudetypItem === '1' )
					{
						this.selectBauartTypItem = '1';
					}
					else if ( this.selectGebaeudetypItem === '-1' )
					{
						this.selectBauartTypItem = '1';
					}

					this.currentobject = this.selectBauartTypItem;

					this.rebuild( this.Root() );
					this.MNHKBox.empty();
					this.showNKHInputFields();
				}

				private buildNewClientModal(): void
				{
					const addCustomerInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
					{
						this.MNewClientInputs.push( input );
						this.MNewClientForm.Input( input );
						input.Base().addClass( baseclass.join( ' ' ) );
					};

					let fg = ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.MNewClientForm.Root() );

					addCustomerInput(
						new ui.Form.Select(
							{
								blank: app.getMessage( 'Realtor.NEW.TITLE.SELECT.gender' ),
								name: 'customer.client.gender',
								option:
								{
									f: app.getMessage( 'Realtor.NEW.TITLE.GENDER.FEMALE.select' ),
									m: app.getMessage( 'Realtor.NEW.TITLE.GENDER.MALE.select' ),
								},
								required: true,
							},
						).rebuild( fg.append( ui.$$.label().text( 'Anrede' + '*' ).addClass( 'control-label col-xs-12 col-md-2' ) ) ),
						[ 'col-xs-12', 'col-md-4' ],
					);

					this.newClientName = new ui.Form.TextInput(
						'',
						{
							name: 'Name',
							placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.name' ),
							required: true,
						},
					);
					addCustomerInput(this.newClientName.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label()
							.text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.name' ) + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MNewClientForm.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ],
					);

					this.newClientSurame = new ui.Form.TextInput(
						'',
						{
							name: 'Surname',
							placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.surname' ),
							required: true,
						},
					);
					addCustomerInput(	this.newClientSurame.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label()
							.text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.surname' ) + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.MNewClientForm.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ],
					);

					fg = ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.Str_HNo' ) + '*' )
						.addClass( 'control-label col-xs-12 col-md-2' ),
					).appendTo( this.MNewClientForm.Root() );

					this.newClientStreet = new ui.Form.TextInput(
					'',
					{
						name: 'Street',
						placeholder: app.getMessage( 'Address.LABEL.LONG.Street' ),
						required: true,
					},
					);
					addCustomerInput( this.newClientStreet.rebuild( fg ),
						[ 'col-xs-12', 'col-md-7' ],
					);

					this.newClientHousenumber =	new ui.Form.TextInput(
					'',
					{
						name: 'Housenumber',
						placeholder: app.getMessage( 'Address.LABEL.LONG.Housenumber' ),
						required: true,
					},
					);
					addCustomerInput( this.newClientHousenumber.rebuild( fg ),
						[ 'col-xs-12', 'col-md-3' ],
					);

					fg = ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.PC_City' ) + '*' )
							.addClass( 'control-label col-xs-12 col-md-2' ),
					).appendTo( this.MNewClientForm.Root() );

					this.newClientPostalCode = new ui.Form.TextInput(
					'',
					{
						name: 'Postalcode',
						placeholder: app.getMessage( 'Address.LABEL.SHORT.Postalcode' ),
						required: true,
					},
					);
					addCustomerInput(	this.newClientPostalCode.rebuild( fg ),
						[ 'col-xs-12', 'col-md-3' ],
					);

					this.newClientCity = new ui.Form.TextInput(
					'',
					{
						name: 'City',
						placeholder: app.getMessage( 'Address.LABEL.LONG.City' ),
						required: true,
					},
					);
					addCustomerInput(	this.newClientCity.rebuild( fg ),
						[ 'col-xs-12', 'col-md-7' ],
					);

					fg = ui.$$.div().addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.email_title' ) + '*' )
						.addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.MNewClientForm.Root() );

					this.newClientEmail =	new ui.Form.EmailInput
					(
						'',
						{
							name: 'Email',
							placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.email_address' ),
							required: true,
						},
					);
					addCustomerInput(	this.newClientEmail.rebuild( fg ),
						[ 'col-xs-12 col-md-10' ],
					);
				}

				private buildOldCustomerForm(): void
				{
					this.MCustomerBox.append(
						$(
							new Button(
							{
								classes: [ 'pull-right' ],
								on:
								{
									click: () =>
									{
										this.MNewClientForm.empty();

										this.MNewClient = new ui.dialog.Modal(
											{
												body: [ this.MNewClientForm ],
												foot:
												[
													$(
														new Button(
														{
															classes: [ 'pull-right' ],
															on:
															{
																click: () =>
																{
																	this.MNewClient.Hide();
																},
															},
															size: 'sm',
															style: 'danger',
															title: 'Abbrechen',
														},
														).getElement(),
													),
													$(
														new Button(
														{
															classes: [ 'pull-right' ],
															on:
															{
																click: () =>
																{
																	let err = false;
																	this.MNewClientInputs.forEach( (element: any) =>
																	{
																		element.addClass('has-success');
																		if ( element.val() === null )
																		{
																			element.addClass('has-error');
																			err = true;
																		}
																	});

																	if ( !err )
																	{
																		new Wollmilch.AJAX(
																		{
																			data:
																			{
																				Email: this.newClientEmail.val(),
																				Gender: this.newClientGender.val() === "Herr" ? '1' : '0',
																				Name: this.newClientName.val(),
																				Salutation: '',
																				Surname: this.newClientSurame.val(),
																				address: {
																					city: this.newClientCity.val(),
																					country: '',
																					housenumber: this.newClientHousenumber.val(),
																					postalcode: this.newClientPostalCode.val(),
																					state: '',
																					street: this.newClientStreet.val(),
																				},
																				phone1: '',
																				phone2: '',
																			},
																			method: 'POST',
																			on:
																			{
																				success: ( text: string ): void =>
																				{
																					let obj = null;
																					try
																					{
																						obj = Wollmilch.jsonize( text );
																					}
																					catch ( e )
																					{
																						app.addNotify(
																						{
																							body: [ ui.text( app.getMessage( 'Customer.New.CLIENT.LINK_FAILED' ) ) ],
																							context: 'warning',
																							timeout: Number(app.getConfigValue("ToastTimeout")),
																							title: [ ui.h( 3, app.getMessage( 'Customer.New.CLIENT.CREATE_TITLE' ) ) ],
																						});
																						return;
																					}
																					if ( obj && !obj.success && obj.error )
																					{
																						app.addNotify(
																						{
																							body: [ ui.text( app.getMessage( 'Customer.New.CLIENT.LINK_FAILED' ) ) ],
																							context: 'warning',
																							timeout: Number(app.getConfigValue("ToastTimeout")),
																							title: [ ui.h( 3, app.getMessage( 'Customer.New.CLIENT.CREATE_TITLE' ) ) ],
																						});
																						return;
																					}
																					app.addNotify(
																					{
																						body: [ ui.text( app.getMessage( 'Customer.New.CLIENT.SUCCESS' ) ) ],
																						context: 'success',
																						timeout: Number(app.getConfigValue("ToastTimeout")),
																						title: [ ui.h( 3, app.getMessage( 'Customer.New.CLIENT.CREATE_TITLE' ) ) ],
																					});

																					inputs[ 'customer.client.gender' ].value( this.newClientGender.val() ? 'Herr' : 'Frau' );
																					inputs[ 'customer.client.name' ].value( this.newClientName.val() );
																					inputs[ 'customer.client.surname' ].value( this.newClientSurame.val() );

																					inputs[ 'customer.address.street' ].value( this.newClientStreet.val() );
																					inputs[ 'customer.address.housenumber' ].value( this.newClientHousenumber.val() );
																					inputs[ 'customer.address.postalcode' ].value( this.newClientPostalCode.val() );
																					inputs[ 'customer.address.city' ].value( this.newClientCity.val() );

																					if ( obj )
																					{
																						inputs[ 'customer.client.id' ].value( obj.data.ID );
																						this.customer = obj.data;
																					}

																				},
																			},
																			url: 'organization/new/Client',
																		},
																		).send();
																		this.MNewClient.Hide();
																	}
																},
															},
															size: 'sm',
															style: 'success',
															title: 'Sichern',
														},
														).getElement(),
													).css('margin-right', '4px'),
												],
												head:	[ ui.$$.h( 4, app.getMessage( 'BWS.LABEL.modalNewClient' ) ) ],
												size: 'lg',
											},
										);
										this.buildNewClientModal();
									},
								},
								size: 'sm',
								style: 'success',
								title: app.getMessage( 'BWS.LABEL.btnNewCLient' ),
							},
							).getElement(),
						),
					);

					const inputs: {[key: string]: ui.Form.BasicInputField} = {};

					this.staticForm = new ui.Form.Form(
					{
						action: 'object/new/DisposalRealtorObject',
						classes: [ 'form-horizontal' ],
						invalid: ( inputs: Array<ui.Form.BasicInputField<HTMLElement>> ) =>
						{
							app.addNotify(
							{
								body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) ) ],
								context: 'danger',
								timeout: Number(app.getConfigValue("ToastTimeout")),
								title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
							});
						},
						method: 'POST',
						notSwitchable: true,
						static: true,
						submit: () => { /* */ },
					},
					).appendTo( this.MCustomerBox ) as ui.Form.Form;
					this.staticForm.Initialize();

					const addCustomerInput = ( input: ui.Form.BasicInputField, baseclass: string[] ): ui.Form.BasicInputField =>
					{
						this.MCustomerInputs.push( input );
						this.staticForm.Input( input );
						input.Base().addClass( baseclass.join( ' ' ) );
						return input;
					};

					this.MCustomerBox.append( ui.$$.h( 4, app.getMessage( 'Realtor.NEW.TITLE.object-client-data-search' ) ) );

					const search: ui.Form.InputTypeahead = new ui.Form.InputTypeahead(
					{
						afterSelect: ( item: Wollmilch.ClientObject ) =>
						{
							this.staticForm.reset();

							inputs[ 'customer.client.gender' ].value( item.Gender === 'm' ? 'Herr' : 'Frau' );
							inputs[ 'customer.client.name' ].value( item.Name );
							inputs[ 'customer.client.surname' ].value( item.Surname );
							inputs[ 'customer.client.id' ].value( item.ID || 0 );

							item.Address.forEach( (adr) =>
								{
									if ( adr.KindOf === 'domicile' && adr.AddressType === 'PostalAddress' )
									{
										const addr: Wollmilch.PostalAddressObject = adr as Wollmilch.PostalAddressObject;

										inputs[ 'customer.address.street' ].value( addr.Street );
										inputs[ 'customer.address.housenumber' ].value( addr.HouseNumber );
										inputs[ 'customer.address.postalcode' ].value( addr.PostalCode );
										inputs[ 'customer.address.city' ].value( addr.City );
									}
								},
							);
							this.customer = item;
							this.HTMLForm = this.convertIntoPostForm( this.staticForm, this.HTMLForm );
						},
						displayText: ( item: Wollmilch.ClientObject ): string =>
						{
							let address: string = "";

							item.Address.forEach( (adr) =>
							{
								if ( adr.KindOf === 'domicile' && adr.AddressType === 'PostalAddress' )
								{
									address = ', ' + adr.display;
								}
							},
							);

							return item.Surname + " " + item.Name + address;
						},
					},
					).rebuild( ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.MCustomerBox.Root() ) )
						.addClass( 'col-xs-12' ) as ui.Form.InputTypeahead;
					this.MCustomerBox.append( ui.$$.p()
						.append( app.getMessage( 'Realtor.NEW.TITLE.CUSTOMER.old-customer-help-text' ) )
						.addClass( 'help-block' ) );

					let fg = ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.MCustomerBox.Root() );

					inputs[ 'customer.client.id' ] = new ui.Form.HiddenNumberInput( -1, 'customer.id' ).rebuild( fg );
					this.MForm.Input( inputs[ 'customer.client.id' ] );

					inputs[ 'customer.client.gender' ] = addCustomerInput(
						new ui.Form.Select(
							{
								blank: ' ',
								name: 'Customer_Salutation',
								option:
								{
									Frau: app.getMessage( 'Realtor.NEW.TITLE.GENDER.FEMALE.select' ),
									Herr: app.getMessage( 'Realtor.NEW.TITLE.GENDER.MALE.select' ),
								},
								required: true,
							},
						).rebuild( fg.append( ui.$$.label().text( 'Kunde' ).addClass( 'control-label col-xs-12 col-md-2' ) ) ),
						[ 'col-xs-12', 'col-md-2' ],
					);

					this.MCustomerInputs.push( inputs[ 'customer.id' ] );
					this.MForm.Input( inputs[ 'customer.id' ] );

					inputs[ 'customer.client.name' ] = addCustomerInput(
						new ui.Form.TextInput(
							'',
							{
								name: 'Customer_Firstname',
								placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.name' ),
								required: true,
							},
						).rebuild( fg ),
						[ 'col-xs-12', 'col-md-4' ],
					);

					inputs[ 'customer.client.surname' ] = addCustomerInput(
						new ui.Form.TextInput(
							'',
							{
								name: 'Customer_Surname',
								placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.surname' ),
								required: true,
							},
						).rebuild( fg ),
						[ 'col-xs-12', 'col-md-4' ],
					);

					fg = ui.$$.div().addClass( 'form-group clearfix' ).append(
						ui.$$.label().text( app.getMessage( 'BWS.INPUTS.streetCombi' ) )
							.addClass( 'control-label col-xs-12 col-md-2' ),
					).appendTo( this.MCustomerBox.Root() );

					inputs[ 'customer.address.street' ] = addCustomerInput(
						new ui.Form.TextInput(
							'',
							{
								name: 'Customer_Street',
								placeholder: app.getMessage( 'Address.LABEL.LONG.Street' ),
								required: true,
							},
						).rebuild( fg ),
						[ 'col-xs-12', 'col-md-7' ],
					);

					inputs[ 'customer.address.housenumber' ] = addCustomerInput(
						new ui.Form.TextInput(
							'',
							{
								name: 'Customer_Housenumber',
								placeholder: app.getMessage( 'Address.LABEL.LONG.Housenumber' ),
								required: true,
							},
						).rebuild( fg ),
						[ 'col-xs-12', 'col-md-3' ],
					);

					fg = ui.$$.div().addClass( 'form-group clearfix' ).append(
						ui.$$.label().text( app.getMessage( 'BWS.INPUTS.cityCombi' ) )
							.addClass( 'control-label col-xs-12 col-md-2' ),
					).appendTo( this.MCustomerBox.Root() );

					inputs[ 'customer.address.postalcode' ] = addCustomerInput(
						new ui.Form.TextInput(
							'',
							{
								name: 'Customer_Postalcode',
								placeholder: app.getMessage( 'Address.LABEL.SHORT.Postalcode' ),
								required: true,
							},
						).rebuild( fg ),
						[ 'col-xs-12', 'col-md-2' ],
					);

					inputs[ 'customer.address.city' ] = addCustomerInput(
						new ui.Form.TextInput(
							'',
							{
								name: 'Customer_City',
								placeholder: app.getMessage( 'Address.LABEL.LONG.City' ),
								required: true,
							},
						).rebuild( fg ),
						[ 'col-xs-12', 'col-md-8' ],
					);

					new Wollmilch.AJAX(
					{
						method: 'GET',
						on:
						{
							success: ( text: string ): void =>
							{
								const obj = Wollmilch.jsonize( text );

								if ( !obj )
								{
									return;
								}

								this.MCustomerList = new Array();

								obj.data.forEach( ( element: any ) => { this.MCustomerList.push( element.Customer ); } );

								search.Source( this.MCustomerList );
							},
						},
						url: 'customer/list/' + this.Company.ID + '/limit/10000000/page/0',
					},
					).send();
				}

		}
	}
}
